import React, { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { LanguageCodes } from '../constants';

/** Languages supported by the application. Must have complete translation files. */
const supportedLngs = Object.values(LanguageCodes);

function LanguageLayout() {
  const { lng } = useParams();
  const { i18n } = useTranslation();

  const supported = supportedLngs.includes(lng);

  useEffect(() => {
    if (supported && i18n.language !== lng) {
      i18n.changeLanguage(lng);
    }
  }, [supported, lng]);

  return supported ? <Outlet /> : <Navigate to="/en" replace />;
}

export default LanguageLayout;
